import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGa4DashboardV1Query } from './get-ga4-dashboard-v1-request';
import type { IGetGa4DashboardV1Response } from './get-ga4-dashboard-v1-response';
import { getGa4DashboardV1ResponseSchema } from './get-ga4-dashboard-v1-response';

export async function getGa4DashboardV1Api(
  query: IGetGa4DashboardV1Query = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGa4DashboardV1Response>> {
  const params = new URLSearchParams();
  if (query.period) {
    params.set('period', query.period);
  }
  if (query.refresh) {
    params.set('refresh', '1');
  }
  const qs = params.toString();
  return getRequest<IGetGa4DashboardV1Response>({
    path: `/sys/ga4/v1/dashboard${qs ? `?${qs}` : ''}`,
    schema: getGa4DashboardV1ResponseSchema,
    options,
  });
}
